import { BillingPlan } from './model';
import SubscriptionPlanType from 'crono-fe-common/types/enums/subscriptionPlanType';
import { PlanPrices } from 'crono-fe-common/types/DTO/SubscriptionPlansDTO';

export type PlanValues = {
  priceId: string;
  billed: BillingPlan;
  plan: SubscriptionPlanType;
};

export enum Plan {
  FREE_TRIAL = 0,
  STARTER = 1,
  PRO = 2,
  ULTRA = 3,
}

export interface Options {
  features: string[];
  id: string | null;
  subscriptionType: SubscriptionPlanType;
  description: string | null;
  prices: PlanPrices[];
}
